<template>
    <oc-page title="Remove account">
        <div class="auth-box account-list" id="remove-account">

            <template v-if="$root.customerLogo !== false">
                <img :src="$root.customerLogo" alt="Customer logo" class="customer-logo" />
                <div class="hr"></div>
            </template>

            <oc-flash-messages />

            <h4 class="section-title">Remove an Account</h4>
            <div class="hr mb-5"></div>

            <div v-for="(user, index) in $root.authInfo.users" class="auth-account-box" :class="'object-color-'+ getColor(index)" @click="deleteUser(user)">
                <div class="beacon-container beacon-big">
                    <div class="beacon-loadingd auth-beacon">
                        <i class="glyphicon glyphicon-user user-icon"></i>
                        <div class="auth-beacon-border"></div>
                    </div>
                </div>
                <div class="auth-account-info">
                    <div class="pull-left">
                        <p class="m-0 account-username" :title="user.username" :class="{center: !user.email}"><b>{{user.username}}</b></p>
                        <p class="m-0 account-email" :title="user.email" v-if="user.email"><i>{{user.email}}</i></p>
                    </div>
                    <oc-icon type="ban" class="pull-right remove-icon" @click="" />
                </div>
            </div>

            <div class="hr mt-5"></div>

            <oc-button-input class="mt-3 btn btn-default btn-block" @click="goBack">
                Done
            </oc-button-input>

        </div>
    </oc-page>
</template>

<script>
import AuthStateMixin from '@/mixins/AuthStateMixin'
import AccountListMixin from '@/pages/auth/mixins/AccountListMixin'

export default {
    name: "remove-account",
    mixins: [AuthStateMixin, AccountListMixin],
    data() {
        return {
        }
    },
    methods: {
        deleteUser(user) {
            this.$dialog.confirm(`Are you sure you want to remove user "${user.username}"?`).then(() => {
                API.POST('login', 'remove-user', {
                    username: user.username
                }).then(response => {
                    this.$store.dispatch('auth/fetchInfo', {force: true}).then(() => {
                        if( this.$root.authInfo.users.length === 0 ) {
                            this.$router.push({path: '/login'})
                        }
                    })
                })
            })
            .catch(() => {})
        },
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>
